import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form, Container, Card, Tooltip, Overlay } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { FaArrowRightToBracket, FaCircleCheck, FaCopy, FaFilePdf } from "react-icons/fa6";
import CheckBox from "../common/customCheckBox";
import { BsShieldFillExclamation } from 'react-icons/bs';
import { downloadSecretPDF } from '../../utils/downloadSecret';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from "react-i18next";

const PopUpPublicIncident = ({
  show,
  handleClose,
  title,
  buttonText,
  label,
  text,
  checkBox,
  onSubmit,
  validationType,
  modalStep,
  readonly,
  value,
  copyClipBoard,
  closeButton,
  download,
  onInputChange,
  pdfData,
  loading,
  loadingText
}) => {
  const [inputValue, setInputValue] = useState("");
  const [isCheckboxChecked, setCheckboxChecked] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [customReadonly, setCustomReadOnly] = useState(readonly);
  const [loadingPdf, setLoadingPdf] = useState(false);

  const [copied, setCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const target = useRef(null);
  const [t] = useTranslation("publicIncident")

  useEffect(() => {
    switch (validationType) {
      case "email_and_checkbox":
        setButtonDisabled(
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
            inputValue
          ) && !isCheckboxChecked
        );

        break;
      case "only_checkbox":
        setButtonDisabled(!isCheckboxChecked);
        break;
      case "only_input":
        setButtonDisabled(!inputValue);
        break;
      default:
        setButtonDisabled(true);
    }
  }, [inputValue, isCheckboxChecked, validationType]);

  useEffect(() => {
    // Reiniciar el estado aquí
    setInputValue("");
    setCheckboxChecked(false);
    // ... resto de tu lógica
  }, [modalStep]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setShowTooltip(true);
    setTimeout(() => {
      setCopied(false);
      setShowTooltip(false);
    }, 4000);
  };

  useEffect(() => {
    // Solo llamar a onInputChange si existe
    if (onInputChange) {
      onInputChange(inputValue);
    }
  }, [inputValue, onInputChange]);


  const handleCheckBox = () => {
    setCheckboxChecked(!isCheckboxChecked)
    if (!isCheckboxChecked && validationType === 'email_and_checkbox') {
      setInputValue("");
      setCustomReadOnly(true);
    } else {
      setCustomReadOnly(false);
    }

  }

  const downloadDoc = (e, data) => {
    setLoadingPdf(true)
    e.preventDefault();
    downloadSecretPDF(data)
    setLoadingPdf(false)


  }


  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Body className='public-modal'>
          <Container>
            <Card className={`mx-auto rounded-border-px custom-shadow border-none  ${modalStep === 1 ? 'p-3' : null}`}>
              {modalStep === 2
                ?
                <div className="modal-title-emphasis">
                  <div ><BsShieldFillExclamation size={35} /></div>
                  <p className="modal-title-emphasis m-0" dangerouslySetInnerHTML={{ __html: text }}></p>
                </div>
                : null}
              <Card.Body className={`d-flex flex-column align-items-center ${modalStep === 2 ? 'pt-0 mb-2 ms-2 me-2' : 'm3'}`}>

                {!closeButton && (
                  <Button
                    variant="none"
                    className="modal-close-button"
                    onClick={handleClose}
                  >
                    <FaTimes className="mb-1" />
                  </Button>
                )}
                <Form className="w-100">
                  {modalStep === 1
                    ?

                    <p className="modal-title mt-2" dangerouslySetInnerHTML={{ __html: text }}></p>

                    : null}
                  <Form.Group controlId={modalStep === 1 ? 'formBasicEmail' : 'formKey'} className="mb-3 mt-3">
                    <Form.Label>{label}</Form.Label>
                    <div className="input-icon-container">
                      <Form.Control
                        type="text"
                        className={`form-text-input ${customReadonly ? "form-text-input-read-only" : ""}`}
                        value={value ? value : inputValue}
                        readOnly={customReadonly}
                        onChange={(e) => setInputValue(e.target.value)}
                      />
                      {copyClipBoard && (
                        <>
                          <span ref={target} className="icon-wrapper">
                            {copied ? (
                              <FaCircleCheck className='modal-copy-icon-2-copied' size={19} onClick={copyToClipboard} />
                            ) : (
                              <FaCopy className='modal-copy-icon-2' onClick={copyToClipboard} size={17} />
                            )}
                          </span>
                          <Overlay target={target.current} show={showTooltip} placement="top">
                            {(props) => (
                              <Tooltip className='overlay-copied-2' id="overlay-copied-2" {...props}>
                                {t("createPopUp.copied")}
                              </Tooltip>
                            )}
                          </Overlay>
                        </>
                      )}
                    </div>
                  </Form.Group>

                  {checkBox && (<>
                    {modalStep === 1 ?
                      <CheckBox initialChecked={false} text={checkBox} onChange={handleCheckBox} key={1} disabled={inputValue} />
                      :
                      <CheckBox initialChecked={false} text={checkBox} onChange={handleCheckBox} key={2} />
                    }
                  </>

                  )}
                  {download && (
                    <div className="text-center mt-auto">
                      <Button
                        variant='secondary'
                        type="submit"
                        className="w-100 mt-4 custom-button-secondary font-color-white custom-shadow login-button"
                        onClick={(e) => downloadDoc(e, pdfData)}
                      >
                        {loadingPdf ?
                          <Spinner animation="border" className="spinner" />
                          :
                          <>
                            <FaFilePdf className="mr-2" />
                            {t("createPopUp.download")}
                          </>
                        }
                      </Button>
                    </div>
                  )}

                  <div className="text-center mt-auto">
                    <Button
                      type="submit"
                      className="w-100 mt-4 background-gradient font-color-white custom-shadow login-button"
                      onClick={(e) => onSubmit(e, inputValue)}
                      disabled={isButtonDisabled}
                    >
                      {loading ?
                        loadingText ?
                          <>
                            <Spinner animation="border" className="spinner me-4" />
                            {loadingText}
                          </>
                          :
                          <Spinner animation="border" className="spinner" />
                        :
                        <>
                          <FaArrowRightToBracket className="mr-2" />
                          {buttonText}
                        </>
                      }
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopUpPublicIncident;
